// extracted by mini-css-extract-plugin
export default {"table":"RequestLogs_table__1mxGb","th":"RequestLogs_th__2Nps6","row":"RequestLogs_row__222ui"};